import axios from "axios";
import { GetProvincesResponse } from "./interfaces/ProvincesResponse";

export const getProvinces = async () => {
    const res = await axios.get<GetProvincesResponse>("/atenea/get-provinces");
    return res.data.provinces[0];
}